import React from "react";
import ArrowIcon from "../Icons/ArrowIcon/ArrowIcon";
import {Grid, Typography} from "@leap4/frontend";

const styles = {
    PlusPercent: {
        color: "green",
    },
    MinusPercent: {
        color: "red",
    },
    ZeroPercent: {
        color: "orange",
    },
    NaNPercent: {
        textAlign: "center" as const,
    }
} as const;


interface IProps {
    percent?: number | null
}

const PercentCell: React.FC<IProps> = ({percent}) => {

    const getStyle = () => {
        if (isNaN(percent)) return styles.NaNPercent;
        if (percent > 0.001) return styles.PlusPercent;
        if (percent < 0) return styles.MinusPercent;
        return styles.ZeroPercent;
    };

    return (
        <Grid container direction={"row-reverse"}  justifyItems={"center"} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
            <Grid item >
                <Typography
                    variant="subtitle1"
                    style={getStyle()}
                    gutterBottom>
                    {
                        (percent || percent === 0) ? `${Math.abs(percent).toFixed(2)} % ` : "NONE"
                    }
                </Typography>
            </Grid>
            <Grid item>
                <ArrowIcon value={percent}/>
            </Grid>
        </Grid>

    );
}



export default PercentCell;
